import { render, staticRenderFns } from "./grupa-delova-vozila.editor.vue?vue&type=template&id=736fff14&scoped=true&"
import script from "./grupa-delova-vozila.editor.vue?vue&type=script&lang=ts&"
export * from "./grupa-delova-vozila.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736fff14",
  null
  
)

export default component.exports